import React from 'react';
import { ArrowRight, Briefcase, Heart } from 'lucide-react';
import { useTranslation } from '../i18n/LanguageContext';

const ServicesSection = () => {
  const { t } = useTranslation();
  
  const scrollToContact = () => {
    const element = document.getElementById('kontakt');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const businessServices = [
    { title: t('business.services.s1.title'), body: t('business.services.s1.body') },
    { title: t('business.services.s2.title'), body: t('business.services.s2.body') },
    { title: t('business.services.s3.title'), body: t('business.services.s3.body') },
    { title: t('business.services.s4.title'), body: t('business.services.s4.body') },
    { title: t('business.services.s5.title'), body: t('business.services.s5.body') },
    { title: t('business.services.s6.title'), body: t('business.services.s6.body') }
  ];

  const weddingServices = [
    { title: t('wedding.services.s1.title'), body: t('wedding.services.s1.body') },
    { title: t('wedding.services.s2.title'), body: t('wedding.services.s2.body') },
    { title: t('wedding.services.s3.title'), body: t('wedding.services.s3.body') },
    { title: t('wedding.services.s4.title'), body: t('wedding.services.s4.body') },
    { title: t('wedding.services.s5.title'), body: t('wedding.services.s5.body') },
    { title: t('wedding.services.s6.title'), body: t('wedding.services.s6.body') }
  ];

  return (
    <>
      {/* Business Section */}
      <section id="business" className="split-section">
        {/* Content Side */}
        <div className="bg-white relative z-10">
          <div className="max-w-xl">
            <div className="inline-flex items-center gap-2 mb-4">
              <Briefcase className="text-gold" size={24} />
              <span className="label-text">{t('business.label')}</span>
            </div>
            <div className="gold-accent mb-6" />
            <h2 className="section-title mb-6">
              {t('business.headline')}
            </h2>
            <p className="body-text mb-8">
              {t('business.body')}
            </p>

            {/* Services List */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
              {businessServices.map((service, index) => (
                <div key={index} className="flex items-start gap-3">
                  <div className="w-1.5 h-1.5 bg-gold rounded-full mt-2 flex-shrink-0" />
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">{service.title}</h4>
                    <p className="text-sm text-gray-600">{service.body}</p>
                  </div>
                </div>
              ))}
            </div>

            <button 
              onClick={scrollToContact}
              className="btn-primary flex items-center gap-2 group"
            >
              {t('business.cta')}
              <ArrowRight size={20} className="group-hover:translate-x-1 transition-transform" />
            </button>
          </div>
        </div>

        {/* Image Side */}
        <div 
          className="relative bg-cover bg-center"
          style={{
            backgroundImage: `url('https://customer-assets.emergentagent.com/job_cift-studio-preview/artifacts/z5nkb389_IMG_1755.PNG')`
          }}
        >
          <div className="absolute inset-0 bg-black/20" />
        </div>
      </section>

      {/* Wedding Section */}
      <section id="wedding" className="split-section">
        {/* Image Side - First on desktop */}
        <div 
          className="relative bg-cover bg-center order-2 md:order-1"
          style={{
            backgroundImage: `url('https://customer-assets.emergentagent.com/job_cift-studio-preview/artifacts/l0evd50s_DSCF1810-2.jpg')`
          }}
        >
          <div className="absolute inset-0 bg-black/20" />
        </div>

        {/* Content Side - Second on desktop */}
        <div className="bg-cream relative z-10 order-1 md:order-2">
          <div className="max-w-xl">
            <div className="inline-flex items-center gap-2 mb-4">
              <Heart className="text-gold" size={24} />
              <span className="label-text">{t('wedding.label')}</span>
            </div>
            <div className="gold-accent mb-6" />
            <h2 className="section-title mb-6">
              {t('wedding.headline')}
            </h2>
            <p className="body-text mb-8">
              {t('wedding.body')}
            </p>

            {/* Services List */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
              {weddingServices.map((service, index) => (
                <div key={index} className="flex items-start gap-3">
                  <div className="w-1.5 h-1.5 bg-gold rounded-full mt-2 flex-shrink-0" />
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">{service.title}</h4>
                    <p className="text-sm text-gray-600">{service.body}</p>
                  </div>
                </div>
              ))}
            </div>

            <button 
              onClick={scrollToContact}
              className="btn-primary flex items-center gap-2 group"
            >
              {t('wedding.cta')}
              <ArrowRight size={20} className="group-hover:translate-x-1 transition-transform" />
            </button>
          </div>
        </div>
      </section>
    </>
  );
};

export default ServicesSection;